module.exports = __webpack_public_path__ + "static/media/logo_ipnet.c2bd5342.JPG";